import React from 'react';
import Notice from '../../common/Notice';

/**
 * Shown above a report that was made with a warning (some data was missing).
 */
export default function StudentReportWarningBanner({ status, error }) {
    if (status !== 'WARNING' || !error?.userMessage) {
        return null;
    }

    return (
        <Notice tone="warning" title="This report may be incomplete">
            {error.userMessage}
        </Notice>
    );
}
